<template>
  <div class="detail-wrap">
    <!-- 返回到按钮 -->
    <i class="back-arrow" @click="goBack"></i>
    <!-- 详情路由 -->
    <main class="detail-main">
      <router-view></router-view>
    </main>
    <!-- 底部图片 -->
    <img class="footer-img" src="../../assets/images/wzb-bg-btm.png" />
  </div>
</template>

<script>
export default {
  name: "detail-index",
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  created() {},
  mounted() {

    // 获取参数并缓存参数
    let miniPartyDetailQuery = this.$route.query;
    // 根据type自动路由
    switch (this.$route.params.type) {
      case "ddw":
        this.$router.replace({ name: "ddw", query: miniPartyDetailQuery });
        break;
      case "ldb":
        this.$router.replace({ name: "ldb", query: miniPartyDetailQuery });
        break;
      case "dzz":
        this.$router.replace({ name: "dzz", query: miniPartyDetailQuery });
        break;
      default:
        break;
    }
  },
  beforeDestroy() {
  }
};
</script>
<style lang="less" scoped>
.detail-wrap {
  .flex(center, @flexDirection:column);
  min-height: 100vh; // 保持至少一屏
  position: relative;
  background: url("../../assets/images/wzb-bg-mid.png") 0 0 no-repeat fixed;
  background-size: 100% 100%;
}
.detail-main {
  flex: 1;
}
.back-arrow {
  .setArrow(left, 0.2rem, #999, 2px);
  position: fixed;
  top: calc(0.4rem + @navigatorHeight);
  left: 0.5rem;
  cursor: pointer;
}
.footer-img {
  display: inline-block;
  width: 100%;
  height: auto;
}
</style>
